import LeftSideBarNavSkyCrest8 from "./LeftSideBarNavSkyCrest8";

const MenuLayoutSkyCrest8 = ({ children }) => {
    return (
        <div>
            <LeftSideBarNavSkyCrest8 />
            {children}
        </div>
    )
}

export default MenuLayoutSkyCrest8;